import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import OrderForm from './pages/OrderForm';
import Confirmation from './pages/Confirmation';
import Tracking from './pages/Tracking';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/order" element={<OrderForm data-id="element-8" />} data-id="element-7" />
            <Route path="/confirmation" element={<Confirmation data-id="element-10" />} data-id="element-9" />
            <Route path="/tracking" element={<Tracking data-id="element-12" />} data-id="element-11" />
          </Routes>
        </main>
        <Footer data-id="element-13" />
      </div>
    </Router>;
}